(() => {
  console.log('[LS UPSELL] loaded ✅');

  const dataNode = document.getElementById('ls-upsell-data');
  if (!dataNode) {
    console.warn('[LS UPSELL] missing #ls-upsell-data');
    return;
  }

  const modal = document.getElementById('ls-upsell-modal');
  if (!modal) {
    console.warn('[LS UPSELL] missing #ls-upsell-modal');
    return;
  }

  const hoodEl = document.getElementById('ls-upsell-hood');
  const linerEl = document.getElementById('ls-upsell-liner');
  const addBtn = document.getElementById('ls-upsell-add');
  const skipBtn = document.getElementById('ls-upsell-skip');

  // NOTE (nouveau HTML: wrapper + texte)
  const noteEl = document.getElementById('ls-upsell-note');
  const noteTextEl = noteEl ? noteEl.querySelector('.ls-upsell-modal__note-text') : null;

  const closeEls = modal.querySelectorAll('[data-ls-upsell-close]');

  const hoodCheck = document.getElementById('ls-upsell-check-hood');
  const linerCheck = document.getElementById('ls-upsell-check-liner');

  let pending = null;   // { mode, variantId }
  let resolved = null;  // { hoodVariantId, linerVariantId }
  let baseConfig = null;

  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  };

  closeEls.forEach(el => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  const setNote = (msg) => {
    if (!noteEl || !noteTextEl) return;
    noteTextEl.textContent = msg || '';
    noteEl.hidden = !msg;
  };

  const money = (cents) => {
    if (typeof cents !== 'number') return '';
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  };

  const norm = (s) =>
    String(s || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/–|—/g, '-');

  const isLetterSize = (v) => {
    const s = norm(v);
    return ['XS','S','M','L','XL','XXL','XXXL','2XL','3XL','4XL','XXXXL'].includes(s);
  };

  const parseUkNumber = (v) => {
    const s = String(v || '').trim();
    const m = s.match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  };

  const normalizeLetterSize = (v) => {
    const s = norm(v);
    if (s === 'XXL') return '2XL';
    if (s === 'XXXL') return '3XL';
    if (s === 'XXXXL') return '4XL';
    return s;
  };

  const altFormsForLetter = (s) => {
    const x = normalizeLetterSize(s);
    if (x === '2XL') return ['2XL','XXL'];
    if (x === '3XL') return ['3XL','XXXL'];
    if (x === '4XL') return ['4XL','XXXXL'];
    return [x];
  };

  // ---- PROFILS UK HOMME (uk_a / uk_b)
  const ukMenToLetterByProfile = (uk, profile) => {
    if (uk == null) return null;
    const p = (profile || 'uk_a').toLowerCase();

    if (p === 'uk_b') {
      if (uk === 32 || uk === 34) return 'XS';
      if (uk === 36) return 'S';
      if (uk === 38 || uk === 40) return 'M';
      if (uk === 42 || uk === 44) return 'L';
      if (uk === 46) return 'XL';
      if (uk === 48) return '2XL';
      if (uk === 50) return '3XL';
      if (uk === 52) return '4XL';
      return null;
    }

    // défaut = uk_a
    if (uk === 32 || uk === 34 || uk === 36) return 'XS';
    if (uk === 38 || uk === 40) return 'S';
    if (uk === 42 || uk === 44) return 'M';
    if (uk === 46) return 'L';
    if (uk === 48) return 'XL';
    if (uk === 50) return '2XL';
    if (uk === 52) return '3XL';
    return null;
  };

  // ---- RÈGLE “1 taille en moins” (avec XS qui reste XS)
  const downOneLetter = (letter) => {
    const s = normalizeLetterSize(letter);
    const map = {
      'XS': 'XS',
      'S':  'XS',
      'M':  'S',
      'L':  'M',
      'XL': 'L',
      '2XL':'XL',
      '3XL':'2XL',
      '4XL':'3XL'
    };
    return map[s] || s;
  };

  // ---- PROFIL alpha_down_custom (table 4)
  const alphaDownCustom = (letter) => {
    const s = normalizeLetterSize(letter);
    const map = {
      'XS': 'XS',
      'S':  'XS',
      'M':  'S',
      'L':  'M',
      'XL': 'L',
      '2XL':'L',
      '3XL':'L',
      '4XL':'L'
    };
    return map[s] || s;
  };

  const getSizingInfoFromVariant = (variant) => {
    const opts = [variant?.option1, variant?.option2, variant?.option3].filter(Boolean);

    const letterRaw = opts.find(isLetterSize);
    if (letterRaw) {
      const size = normalizeLetterSize(letterRaw);
      const color = opts.find(v => v !== letterRaw) || '';
      return { kind: 'letter', value: size, color };
    }

    const nums = opts.map(parseUkNumber).filter(n => typeof n === 'number' && !Number.isNaN(n));
    const uk = nums.length ? nums[0] : null;

    if (uk != null) {
      const color = opts.find(v => parseUkNumber(v) !== uk) || '';
      return { kind: 'uk_number', uk, color };
    }

    return { kind: 'unknown', value: null, color: '' };
  };

  const fetchVariantById = async (variantId) => {
    if (!variantId) return null;
    const res = await fetch(`/variants/${variantId}.js`, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) return null;
    return await res.json();
  };

  const fetchProductByHandle = async (handle) => {
    if (!handle) return null;
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) return null;
    return await res.json();
  };

  const firstAvailableVariant = (productJson) => {
    if (!productJson?.variants?.length) return null;
    return productJson.variants.find(v => v.available) || productJson.variants[0] || null;
  };

  const findVariantByOptionValue = (productJson, optionNameCandidates, wantedValue) => {
    if (!productJson || !wantedValue) return null;

    const options = productJson.options || [];
    let idx = -1;

    for (const name of optionNameCandidates) {
      const i = options.findIndex(o => String(o || '').toLowerCase() === String(name).toLowerCase());
      if (i >= 0) { idx = i; break; }
    }
    if (idx < 0) idx = 0;

    const wantedN = String(wantedValue).trim().toUpperCase();

    for (const v of productJson.variants || []) {
      const value = idx === 0 ? v.option1 : (idx === 1 ? v.option2 : v.option3);
      if (String(value || '').trim().toUpperCase() === wantedN) return v;
    }
    return null;
  };

  const renderUpsellCard = (container, productJson, variant, label) => {
    const img = container.querySelector('img');
    const name = container.querySelector('.ls-upsell-item__name');
    const meta = container.querySelector('.ls-upsell-item__meta');
    const price = container.querySelector('.ls-upsell-item__price');

    const imageUrl =
      (variant?.featured_image?.src) ||
      (productJson?.images?.[0]) ||
      '';

    if (img) { img.src = imageUrl; img.alt = productJson?.title || ''; }
    if (name) name.textContent = productJson?.title || '';
    if (meta) meta.textContent = label || '';
    if (price) price.textContent = money(variant?.price);

    container.hidden = false;
  };

  const addItems = async (items) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error(`add_failed: ${txt}`);
    }

    return await res.json();
  };

  const openCartAfterRefresh = async () => {
    const cart = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(r => r.json()).catch(() => null);

    document.dispatchEvent(new CustomEvent('on:cart:change', { detail: { cart } }));
    await new Promise(r => setTimeout(r, 120));

    const headerCartBtn =
      document.querySelector('[data-cart-drawer-toggle]') ||
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('a[href="/cart"]');

    if (headerCartBtn) headerCartBtn.click();
    else window.location.href = '/cart';
  };

  const resolveUpsells = async () => {
    baseConfig = JSON.parse(dataNode.textContent || '{}');

    const sizingProfile = (baseConfig.linerSizingProfile || 'uk_a').toLowerCase();
    const linerSameSize = !!baseConfig.linerSameSize;

    if (hoodEl) hoodEl.hidden = true;
    if (linerEl) linerEl.hidden = true;

    // reset note
    setNote('');

    const selectedVariant = await fetchVariantById(pending?.variantId);
    const info = getSizingInfoFromVariant(selectedVariant);

    // ✅ Taille “source”
    let baseSize = null;

    if (info.kind === 'letter') {
      baseSize = info.value; // "M"
    } else if (info.kind === 'uk_number') {
      const uk = info.uk;

      if (sizingProfile === 'women_num') {
        baseSize = (uk != null ? String(uk) : null);
      } else if (sizingProfile === 'uk_identity') {
        baseSize = (uk != null ? String(uk) : null);
      } else {
        baseSize = ukMenToLetterByProfile(uk, sizingProfile);
      }
    }

    console.log('[LS UPSELL] info:', info, 'profile:', sizingProfile, 'linerSameSize:', linerSameSize, 'baseSize:', baseSize);

    const hoodProduct  = await fetchProductByHandle(baseConfig.hoodHandle);
    const linerProduct = await fetchProductByHandle(baseConfig.linerHandle);

    let hoodVariant = null;
    let linerVariant = null;

    // --- CAPUCHE : match couleur si possible
    if (hoodProduct) {
      hoodVariant =
        (info.color ? findVariantByOptionValue(hoodProduct, ['Couleur', 'Color'], info.color) : null) ||
        firstAvailableVariant(hoodProduct);

      if (hoodVariant && hoodEl) {
        const label = info.color ? `Capuche — ${info.color}` : 'Capuche — couleur assortie';
        renderUpsellCard(hoodEl, hoodProduct, hoodVariant, label);
      }
    }

    // --- DOUBLURE
    if (linerProduct) {
      let recommended = baseSize;

      if (recommended && sizingProfile === 'alpha_down_custom') {
        recommended = alphaDownCustom(recommended);
      } else if (recommended && (sizingProfile === 'uk_identity' || sizingProfile === 'women_num')) {
        // rien (numérique)
      } else if (recommended && !linerSameSize && isLetterSize(recommended)) {
        recommended = downOneLetter(recommended);
      }

      if (!recommended) {
        setNote("Impossible de déterminer la taille recommandée de la doublure.");
      } else {
        let candidates = [recommended];
        if (isLetterSize(recommended)) candidates = altFormsForLetter(recommended);

        for (const c of candidates) {
          linerVariant = findVariantByOptionValue(linerProduct, ['Taille', 'Size'], c);
          if (linerVariant) break;
        }

        if (!linerVariant) {
          setNote(`Doublure indisponible en taille recommandée (${recommended}).`);
        } else if (linerEl) {
          renderUpsellCard(linerEl, linerProduct, linerVariant, `Doublure — taille recommandée (${recommended})`);
        }
      }
    }

    resolved = {
      hoodVariantId: hoodVariant ? hoodVariant.id : null,
      linerVariantId: linerVariant ? linerVariant.id : null
    };

    if (hoodCheck) hoodCheck.checked = !!resolved.hoodVariantId;
    if (linerCheck) linerCheck.checked = !!resolved.linerVariantId;
  };

  addBtn.addEventListener('click', async () => {
    if (!pending?.variantId) return;

    const items = [{ id: pending.variantId, quantity: 1 }];

    const wantHood  = hoodCheck ? hoodCheck.checked : true;
    const wantLiner = linerCheck ? linerCheck.checked : true;

    if (resolved?.hoodVariantId && wantHood) items.push({ id: resolved.hoodVariantId, quantity: 1 });
    if (resolved?.linerVariantId && wantLiner) items.push({ id: resolved.linerVariantId, quantity: 1 });

    addBtn.disabled = true;
    skipBtn.disabled = true;

    try {
      await addItems(items);
      closeModal();
      if (pending.mode === 'checkout') window.location.href = '/checkout';
      else await openCartAfterRefresh();
    } catch (e) {
      console.error('[LS UPSELL] add failed', e);
      setNote("Impossible d’ajouter au panier. Actualisez la page et réessayez.");
    } finally {
      addBtn.disabled = false;
      skipBtn.disabled = false;
    }
  });

  skipBtn.addEventListener('click', async () => {
    if (!pending?.variantId) return;

    addBtn.disabled = true;
    skipBtn.disabled = true;

    try {
      await addItems([{ id: pending.variantId, quantity: 1 }]);
      closeModal();
      if (pending.mode === 'checkout') window.location.href = '/checkout';
      else await openCartAfterRefresh();
    } catch (e) {
      console.error('[LS UPSELL] skip add failed', e);
      setNote("Impossible d’ajouter au panier. Actualisez la page et réessayez.");
    } finally {
      addBtn.disabled = false;
      skipBtn.disabled = false;
    }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target?.closest?.('button[type="submit"], button[name="add"], .product-form__submit');
    if (!btn) return;

    const form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    const cfg = JSON.parse(dataNode.textContent || '{}');
    if (!cfg.hoodHandle && !cfg.linerHandle) return;

    const fd = new FormData(form);
    const id = fd.get('id');
    const variantId = id ? parseInt(String(id), 10) : null;
    if (!variantId) return;

    const text = (btn.textContent || '').toLowerCase();
    const isBuyNow = text.includes('acheter') || text.includes('buy now') || text.includes('buy');

    e.preventDefault();
    e.stopPropagation();

    pending = { mode: isBuyNow ? 'checkout' : 'cart', variantId };
    await resolveUpsells();
    openModal();
  }, true);
})();